export default __webpack_public_path__ + "static/media/skill_python.2e65c2b7.png";